export default class LanguageUtil {
  static updateLanguage(props, language) {
    props.i18n.changeLanguage(language);
    sessionStorage.setItem("lang", language);
  }
}
